import { Text } from '@chakra-ui/react'

import Image from '@/features/Services/components/atoms/Images/Vendor'

import {
  TITLE_H1_STYLE,
  TITLE_H2_STYLE,
  TITLE_H3_STYLE,
  PARAGRAPH_STYLE,
} from './style'

import { Policy } from '@/features/Services/types'

const HREF = 'serviceVendor'

const TITLE = 'Vendor Privacy Policy'
const SUBTITLE = 'นโยบายการสรรหาและคัดเลือกบุคลากร'

const PRIMARY_COLOR = '#2D89F7'
const SECONDARY_COLOR = '#FBFBFF'
const LINK_IMAGE = '/images/services/vendor/4.jpg'
const GRADIENT = `linear-gradient(0deg, ${PRIMARY_COLOR}7F 0%, ${PRIMARY_COLOR}FF 100%)`

const POLICY: Policy[] = [
  {
    title: (
      <Text as="h1" sx={TITLE_H1_STYLE}>
        Vendor
        <br />
        Privacy Policy
      </Text>
    ),
    paragraph: (
      <Text sx={PARAGRAPH_STYLE}>
        สำหรับองค์กรที่มีการเก็บรวบรวม ใช้ หรือเปิดเผย
        ข้อมูลส่วนบุคคลของคู่ค้าหรือผู้ให้บริการ
        เมื่อองค์กรมีการทำสัญญาหรือธุรกรรมร่วมกับคู่ค้า
        หรือเมื่อองค์กรได้มีการใช้บริการจากผู้ให้บริการ เช่น ชื่อ นามสกุล
        ข้อมูลทางการเงิน เพื่อนำมาใช้ใน กระบวนการประเมินการจัดซื้อจัดจ้าง
        เป็นต้น
      </Text>
    ),
    image: '/images/services/vendor/header.svg',
    imageAspectRatio: 645 / 654,
    button: {
      label: 'สร้าง Policy ตอนนี้!',
      href: '/create/policy?template=vendor',
      logEvent: {
        ga: { category: TITLE, action: 'Click create policy' },
      },
    },
  },
  {
    title: (
      <Text as="h1" sx={TITLE_H2_STYLE}>
        Vendor Privacy Policy
        <br />
        จำเป็นอย่างไร?
      </Text>
    ),
    paragraph: (
      <Text sx={PARAGRAPH_STYLE}>
        เพื่อแจ้งวัตถุประสงค์และแนวปฏิบัติของการประมวลผลข้อมูลส่วนบุคคลตามพ.ร.บ.
        คุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 สำหรับองค์กรที่มีการเก็บรวบรวม ใช้
        หรือเปิดเผยข้อมูลส่วนบุคคลของคู่ค้าหรือผู้ให้บริการ
        เพื่อนำมาใช้ในกระบวนการทำสัญญา กระบวนการจัด ซื้อจัดจ้างหรือการใช้บริการ
        โดยกระบวนการดังกล่าว ทำให้องค์กรมีหน้าที่จัดทำนโยบายความเป็นส่วนตัว
        สำหรับคู่ค้าหรือผู้ให้บริการ (Vendor Privacy Policy)
      </Text>
    ),
    image: '/images/services/vendor/2.jpg',
    imageAspectRatio: 1,
  },
  {
    title: (
      <Text as="h2" sx={TITLE_H3_STYLE}>
        Vendor Privacy Policy
        <br />
        ครอบคลุมเรื่องอะไรบ้าง ?
      </Text>
    ),
    paragraph: (
      <Text sx={PARAGRAPH_STYLE}>
        นโยบายความเป็นส่วนตัวสำหรับคู่ค้าหรือผู้ให้บริการ
        ครอบคลุมรายละเอียดการปฏิบัติต่อข้อมูลส่วนบุคคลที่มีการเก็บรวบรวม ใช้
        หรือเปิดเผยไปจนถึงมาตรการ จัดการด้านความปลอดภัยขององค์กรเพื่อคุ้มครอง
        ข้อมูลส่วนบุคคลของคู่ค้าหรือผู้ให้บริการ และระบุถึง
        วัตถุประสงค์ของการประมวลผลข้อมูลส่วนบุคคล ตลอดจนสิทธิต่าง ๆ
        ที่คู่ค้าหรือผู้ให้บริการมีภายใต้ พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคล พ.ศ.
        2562
      </Text>
    ),
    checkList: [
      'ปรับใช้ได้กับทุกธุรกิจ',
      'สอดคล้องตามกฎหมาย PDPA',
      'คัดลอกลิงก์ policy หรือดาวน์โหลด',
    ],
    image: <Image />,
  },
]

export default {
  PRIMARY_COLOR,
  SECONDARY_COLOR,
  POLICY,
  HREF,
  LINK_IMAGE,
  GRADIENT,
  TITLE,
  SUBTITLE,
}
